import {action, computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import {default as handleErrorToast} from "../../../components/toast/ErrorToast";
import {default as handleSuccessToast} from "../../../components/toast/SuccessToast";
import LegalEntityForm from "../../../domain/LegalEntityForm";
import CustomerOnboardingPanelFeature from "./CustomerOnboardingPanelFeature";

export default class LegalEntityPanelFeature extends CustomerOnboardingPanelFeature {

    constructor(application, generalFeature) {
        super(application, generalFeature);
        this._legalEntityForm = null;

        makeObservable(this, {
            _legalEntityForm: observable,
            legalEntityForm: computed,
            editLegalEntity: action,
        })
    }

    async load() {
        this.createCustomerForm();
        this.finishLoading();
    }

    async formChanged(legalEntity) {
        await this.editLegalEntity(legalEntity)
    }

    createCustomerForm() {
        this._legalEntityForm = LegalEntityForm.newFor(this.customerOnboarding().request.legalEntity, this, this.customerOnboarding().configuration);
    }

    async editLegalEntity(legalEntity) {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                await this.customerOnboardingHasChanged()
                this.createCustomerForm();
                handleSuccessToast("Datos del cliente guardados correctamente.");
            },
            handlesError: (response) => {
                handleErrorToast("No se pudieron guardar los datos del cliente.");
            }
        });
        return this._application.apiClient().editLegalEntity(legalEntity, responseHandler);
    }

    canEditLegalEntity() {
        return true;
    }

    createForm(){
        return this.createCustomerForm()
    }

    get form() {
        return this._legalEntityForm;
    }

    get legalEntityForm() {
        return this._legalEntityForm;
    }

    get taxpayerIdentificationNumber() {
        return this._customerOnboarding.request.taxpayerIdentificationNumber;
    }

    jurisdictions() {
        return [
            'Buenos Aires',
            'Catamarca',
            'Chaco',
            'Chubut',
            'Capital Federal',
            'Córdoba',
            'Corrientes',
            'Entre Ríos',
            'Formosa',
            'Jujuy',
            'La Pampa',
            'La Rioja',
            'Mendoza',
            'Misiones',
            'Neuquén',
            'Río Negro',
            'Salta',
            'San Juan',
            'San Luis',
            'Santa Cruz',
            'Santa Fe',
            'Santiago del Estero',
            'Tierra del Fuego',
            'Tucumán',
        ];
    }

    jurisdictionsOptions() {
        return this.jurisdictions().map(jurisdiction => {
            return {label: jurisdiction, value: jurisdiction}
        });
    }
}
